<template>
    <div>
        <LoadingOverlay :loading="loading" />
        <div class="listingPattern">
            <div class="fixHeight ringlive-datalistWrap">
                <div class="listBoxes" v-for="(reward, index) in RoomThisweekData " :key="reward.id">
                    <div class="leftBxb">
                        <div class="s-no">{{ index + 1 }}</div>
                        <div class="listIconBox">
                            <div class="profPic">
                                <img :src='(reward.pic.length > 0) ? reward.pic : defaultUserImage' alt="User Image" />
                            </div>
                        </div>
                        <div class="name-lavel-box">
                            <div class="userName">{{ reward.name }}</div>
                        </div>
                    </div>
                    <div class="rightBox">
                        <div class="rightBox-in">
                            <img :src='beansIcon' class="beansIcon" alt="beans icons" />
                            {{ reward.total_earning }}
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="personalDetails" class="listBoxes myselfBox">
                <div class="leftBxb">
                    <div class="s-no">-</div>
                    <div class="listIconBox">
                        <div class="profPic">
                            <img :src='(personalDetails.pic.length > 0) ? personalDetails.pic : defaultUserImage'
                                alt="User Image" />
                        </div>
                    </div>
                    <div class="name-lavel-box">
                        <div class="userName">{{ personalDetails.name }}</div>
                    </div>
                </div>
                <div class="rightBox">
                    <div class="rightBox-in">
                        <img :src='beansIcon' class="beansIcon" alt="beans icons" />
                        {{ personalDetails.total_earning }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import beansIcon from '../../assets/images/beansIcon.png'
import defaultUserImage from '../../assets/images/default_profile.webp';
import LoadingOverlay from '../LoadingOverlay.vue'
export default {
    name: 'RoomThisWeekTabCont',
    components: {
        LoadingOverlay
    },
    data() {
        return {
            RoomThisweekData: [],
            personalDetails: null,
            beansIcon: beansIcon,
            defaultUserImage: defaultUserImage,
            loading: false,
        }
    },
    watch: {
        '$route.params.profile_id': 'fetchRoomThisweekData'
    },
    mounted() {
        this.fetchRoomThisweekData();
    },
    methods: {
        fetchRoomThisweekData() {
            this.loading= true;
            const tokenParam = this.$route.params.token;
            const token = tokenParam.split('=')[0];
            const apiUrl = `api/top-privateroom-weekly?type=this_week`;
            axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            })
                .then(response => {
                    this.RoomThisweekData = response.data.result.data;
                    this.personalDetails = response.data.result.personal_details;
                    this.checkAllImagesExist();
                })

                .catch(error => {
                    console.error("Error Featching This Week Data", error)
                })
                .finally(() => {
                    this.loading = false;
                })
        },
        checkAllImagesExist() {
            this.RoomThisweekData.forEach(reward => {
                if (reward.length > 0) {
                    const imageUrl = reward.pic;
                    this.checkImageExists(imageUrl)
                        .then(exists => {
                            if (!exists) {
                                reward.pic = this.defaultUserImage;
                            }
                        });
                }
            });
        },
        checkImageExists(imageUrl) {
            return new Promise((resolve) => {
                var img = new Image();
                img.onload = function () {
                    resolve(true);
                };
                img.onerror = function () {
                    resolve(false);
                };
                img.src = imageUrl;
            });
        }
    },
}
</script>